import React, {useEffect} from "react";
import ActionCard from "./ActionCard";
import useFilterUser from "../../custom-hooks/useFilterUser";
import {useSelector} from "react-redux";
import styled from "styled-components";

const ActionsList = ({actions, query, inActionPage, setNumberOfActions, projectName}) => {

    const {id: projectId} = useSelector(state => state.project)
    const {
        getFullNameInverseNoWhiteSpace,
        getFullNameNoWhiteSpace,
        getQueryNoWhiteSpace,
    } = useFilterUser(actions)

    useEffect(() => {
        setNumberOfActions(actions.filter(a =>
            a.name.toLowerCase().includes(query.toLowerCase()) ||
            getFullNameNoWhiteSpace(a.pilot).includes(getQueryNoWhiteSpace(query)) ||
            getFullNameInverseNoWhiteSpace(a.pilot).includes(getQueryNoWhiteSpace(query)) || (projectName ?
                a.projectName.toLowerCase().includes(query.toLowerCase()) : "")
        ).length)
    }, [query, setNumberOfActions, actions, getFullNameNoWhiteSpace, getQueryNoWhiteSpace, getFullNameInverseNoWhiteSpace,projectName])

    const displayActionCard = (dataSelected) => {
        if(!inActionPage){
             dataSelected.sort((data) => {
                 if(data.advancement === 100) return 1
                 if (data.advancement < 100) return -1
                 return  0
             })
        }

        if (dataSelected.length === 0) {
            return (
                <h1> Pas d'action définie avec cette sélection </h1>
            )
        }
        return (
            dataSelected
                .filter(a =>
                    a.name.toLowerCase().includes(query.toLowerCase()) ||
                    getFullNameNoWhiteSpace(a.pilot).includes(getQueryNoWhiteSpace(query)) ||
                    getFullNameInverseNoWhiteSpace(a.pilot).includes(getQueryNoWhiteSpace(query)) ||
                    (projectName ?
                        a.projectName.toLowerCase().includes(query.toLowerCase()) : "")
                )
                .map(a => (
                    <ActionCard
                        key={a.id}
                        actionId={a.id}
                        pilot={a.pilot}
                        name={a.name}
                        criticality={a.criticality}
                        deadline={a.deadline}
                        advancement={a.advancement}
                        tags={a.tags}
                        completedDate={a.firstTimeCompleted}
                        creationDate={a.creationDate}
                        projectId={projectId}
                        keyResultId={a.keyResultId}
                        keyResultTitle={a.keyResultTitle}
                        projectName={a.projectName}
                        inActionPage={inActionPage}
                        fromCascade={false}
                        fromOkrs={false}
                    />
                ))
        )
    }

    return (
        actions?.length === 0
            ?
            <h1> Il n'y a pas d'action définie avec cette sélection </h1>
            :
            <List>
                {displayActionCard(actions)}
            </List>


    )
}

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 90%;
  margin: 0 1rem;
  align-items:center;
`

export default ActionsList